import { render, staticRenderFns } from "./LocationItems.vue?vue&type=template&id=9218e4e0&"
import script from "./LocationItems.vue?vue&type=script&lang=js&"
export * from "./LocationItems.vue?vue&type=script&lang=js&"
import style0 from "./LocationItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports